import { render, staticRenderFns } from "./LexonDropdownListOptionsComponent.vue?vue&type=template&id=15b260c4&scoped=true&lang=pug"
import script from "./LexonDropdownListOptionsComponent.vue?vue&type=script&lang=ts"
export * from "./LexonDropdownListOptionsComponent.vue?vue&type=script&lang=ts"
import style0 from "./LexonDropdownListOptionsComponent.vue?vue&type=style&index=0&id=15b260c4&lang=scss&scoped=true"
import style1 from "./LexonDropdownListOptionsComponent.vue?vue&type=style&index=1&id=15b260c4&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b260c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b260c4')) {
      api.createRecord('15b260c4', component.options)
    } else {
      api.reload('15b260c4', component.options)
    }
    module.hot.accept("./LexonDropdownListOptionsComponent.vue?vue&type=template&id=15b260c4&scoped=true&lang=pug", function () {
      api.rerender('15b260c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonDropdownListOptions/LexonDropdownListOptionsComponent.vue"
export default component.exports